tinymce.addI18n("lt", {
    "#": "#",
    "Accessibility": "Prieinamumas",
    "Accordion": "I\u0161skleid\u017eiamas elementas",
    "Accordion body...": "I\u0161skleid\u017eiamo elemento turinys...",
    "Accordion summary...": "I\u0161skleid\u017eiamo elemento antra\u0161t\u0117...",
    "Action": "Veiksmas",
    "Activity": "Veikla",
    "Address": "Adresas",
    "Advanced": "I\u0161pl\u0117stas",
    "Align": "Lygiavimas",
    "Align center": "Centruoti",
    "Align left": "Lygiuoti kair\u0117je",
    "Align right": "Lygiuoti de\u0161in\u0117je",
    "Alignment": "Lygiavimas",
    "Alignment {0}": "Lygiavimas {0}",
    "All": "Visi",
    "Alternative description": "Alternatyvus apra\u0161ymas",
    "Alternative source": "Alternatyvus \u0161altinis",
    "Alternative source URL": "Alternatyvus \u0161altinio URL adresas",
    "Anchor": "\u017dym\u0117",
    "Anchor...": "Nuoroda...",
    "Anchors": "\u017dym\u0117",
    "Animals and Nature": "Gyv\u016bnai ir gamta",
    "Arrows": "Rodykl\u0117s",
    "B": "M",
    "Background color": "Fono spalva",
    "Background color {0}": "Fono spalva {0}",
    "Black": "Juoda",
    "Block": "Blokas",
    "Block {0}": "Blokas {0}",
    "Blockquote": "Citata",
    "Blocks": "Blokai",
    "Blue": "M\u0117lyna",
    "Blue component": "M\u0117lynas komponentas",
    "Body": "Turinys",
    "Bold": "Pary\u0161kintas",
    "Border": "R\u0117melis",
    "Border color": "R\u0117melio spalva",
    "Border style": "Kra\u0161tin\u0117s stilius",
    "Border width": "Kra\u0161tin\u0117s plotis",
    "Bottom": "Apa\u010dioje",
    "Browse files": "Nar\u0161yti failus",
    "Browse for an image": "Ie\u0161koti paveiksl\u0117lio",
    "Browse links": "Nar\u0161yti nuorodas",
    "Bullet list": "\u017denklinimo s\u0105ra\u0161as",
    "Cancel": "Atsisakyti",
    "Caption": "Antra\u0161t\u0117",
    "Cell": "Langeliai",
    "Cell padding": "Tarpas nuo langelio iki teksto",
    "Cell properties": "Langelio savyb\u0117s",
    "Cell spacing": "Tarpas tarp langeli\u0173",
    "Cell styles": "Langelio stiliai",
    "Cell type": "Langelio tipas",
    "Center": "Centras",
    "Characters": "Simboli\u0173",
    "Characters (no spaces)": "Simboli\u0173 (be tarp\u0173)",
    "Circle": "Apskritimas",
    "Class": "Klas\u0117",
    "Clear formatting": "Naikinti formatavim\u0105",
    "Close": "U\u017edaryti",
    "Code": "Kodas",
    "Code sample...": "Kodo pavyzdys...",
    "Code view": "Kodo per\u017ei\u016bra",
    "Color Picker": "Spalvos parinkimas",
    "Color swatch": "Spalv\u0173 pavyzd\u017eiai",
    "Cols": "Stulpeliai",
    "Column": "Stulpelis",
    "Column clipboard actions": "Stulpelio main\u0173 srities veiksmai",
    "Column group": "Stulpeli\u0173 grup\u0117",
    "Column header": "Stulpelio antra\u0161t\u0117",
    "Constrain proportions": "Taikyti proporcijas",
    "Copy": "Kopijuoti",
    "Copy column": "Kopijuoti stulpel\u012f",
    "Copy row": "Kopijuoti eilut\u0119",
    "Could not find the specified string.": "Nepavyko rasti nurodytos eilut\u0117s.",
    "Could not load emojis": "Nepavyko \u012fkelti jaustuk\u0173",
    "Count": "Skai\u010dius",
    "Currency": "Valiuta",
    "Current window": "Dabartiniame lange",
    "Custom color": "Pasirinktina spalva",
    "Custom...": "Pasirinktinas...",
    "Cut": "I\u0161kirpti",
    "Cut column": "I\u0161kirpti stulpel\u012f",
    "Cut row": "I\u0161kirpti eilut\u0119",
    "Dark Blue": "Tamsiai m\u0117lyna",
    "Dark Gray": "Tamsiai pilka",
    "Dark Green": "Tamsiai \u017ealia",
    "Dark Orange": "Tamsiai oran\u017ein\u0117",
    "Dark Purple": "Tamsiai violetin\u0117",
    "Dark Red": "Tamsiai raudona",
    "Dark Turquoise": "Tamsiai \u017ealsvai m\u0117lyna",
    "Dark Yellow": "Tamsiai geltona",
    "Dashed": "Br\u016bk\u0161ninis",
    "Date/time": "Data / laikas",
    "Decrease indent": "Ma\u017einti \u012ftrauk\u0105",
    "Default": "Pagrindinis",
    "Delete accordion": "I\u0161trinti i\u0161skleid\u017eiam\u0105 element\u0105",
    "Delete column": "Naikinti stulpel\u012f",
    "Delete row": "Naikinti eilut\u0119",
    "Delete table": "\u0160alinti lentel\u0119",
    "Dimensions": "Matmenys",
    "Disc": "Diskas",
    "Div": "Div",
    "Document": "Dokumentas",
    "Dotted": "Ta\u0161kinis",
    "Double": "Dvigubas",
    "Drop an image here": "Tempkite paveiksl\u0117l\u012f \u010dia",
    "Dropped file type is not supported": "Numesto failo tipas nepalaikomas",
    "Edit": "Redaguoti",
    "Embed": "\u012eterpti",
    "Emojis": "Jaustukai",
    "Emojis...": "Jaustukai...",
    "Error": "Klaida",
    "Error: Form submit field collision.": "Klaida: formos lauk\u0173 nesuderinamumas.",
    "Error: No form element found.": "Klaida: formos element\u0173 nerasta.",
    "Extended Latin": "Lotyn\u0173 i\u0161pl\u0117stin\u0117",
    "Failed to initialize plugin: {0}": "Priedo inicijuoti nepavyko: {0}",
    "Failed to load plugin url: {0}": "Priedo adreso \u012fkelti nepavyko: {0}",
    "Failed to load plugin: {0} from url {1}": "Priedo \u012fkelti nepavyko: {0} i\u0161 adreso {1}",
    "Failed to upload image: {0}": "Paveiksl\u0117lio \u012fkelti nepavyko: {0}",
    "File": "Failas",
    "Find": "Ie\u0161koti",
    "Find (if searchreplace plugin activated)": "Ie\u0161koti (jei searchreplace priedas aktyvuotas)",
    "Find and Replace": "Surasti ir Pakeisti",
    "Find and replace...": "Ie\u0161koti ir pakeisti...",
    "Find in selection": "Ie\u0161koti pasirinkime",
    "Find whole words only": "Ie\u0161koti tik vis\u0105 \u017eod\u012f",
    "Flags": "V\u0117liavos",
    "Focus to contextual toolbar": "Fokusuoti \u012f kontekstin\u012f \u012franki\u0173 juost\u0105",
    "Focus to element path": "Fokusuoti \u012f elemento keli\u0105",
    "Focus to menubar": "Fokusuoti \u012f meniu",
    "Focus to toolbar": "Fokusuoti \u012f \u012franki\u0173 juost\u0105",
    "Font": "\u0160riftas",
    "Font size {0}": "\u0160rifto dydis {0}",
    "Font sizes": "\u0160rift\u0173 dyd\u017eiai",
    "Font {0}": "\u0160riftas {0}",
    "Fonts": "\u0160riftai",
    "Food and Drink": "Maistas ir g\u0117rimai",
    "Footer": "Apa\u010dia",
    "Format": "Formatas",
    "Format {0}": "Formatas {0}",
    "Formats": "Formatai",
    "Fullscreen": "Visas ekranas",
    "G": "\u017d",
    "General": "Pagrindinis",
    "Gray": "Pilka",
    "Green": "\u017dalia",
    "Green component": "\u017dalias komponentas",
    "Groove": "Banguotas",
    "Handy Shortcuts": "Patogios nuorodos",
    "Header": "Antra\u0161t\u0117",
    "Header cell": "Antra\u0161t\u0117s langelis",
    "Heading 1": "Antra\u0161t\u0117 1",
    "Heading 2": "Antra\u0161t\u0117 2",
    "Heading 3": "Antra\u0161t\u0117 3",
    "Heading 4": "Antra\u0161t\u0117 4",
    "Heading 5": "Antra\u0161t\u0117 5",
    "Heading 6": "Antra\u0161t\u0117 6",
    "Headings": "Antra\u0161t\u0117s",
    "Height": "Auk\u0161tis",
    "Help": "Pagalba",
    "Hex color code": "\u0160e\u0161ioliktainis spalvos kodas",
    "Hidden": "Pasl\u0117ptas",
    "Horizontal align": "Horizontalus lygiavimas",
    "Horizontal line": "Horizontali linija",
    "Horizontal space": "Horizontalus tarpas",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID tur\u0117t\u0173 prasid\u0117ti raide, po kurios gali b\u016bti raid\u0117s, skai\u010diai, br\u016bk\u0161niai, ta\u0161kai, dvita\u0161kiai ir pabraukimai.",
    "Image is decorative": "Paveiksl\u0117lis yra papuo\u0161imas",
    "Image list": "Paveiksl\u0117li\u0173 s\u0105ra\u0161as",
    "Image title": "Paveiksl\u0117lio pavadinimas",
    "Image...": "Paveiksl\u0117lis...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP klaida: nepavyko rasti paveiksl\u0117li\u0173 tarpin\u0117s programos",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP klaida: neteingas paveiksl\u0117li\u0173 tarpin\u0117s programos URL adresas",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP klaida: u\u017eklausa atmesta",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP klaida: ne\u017einoma ImageProxy klaida",
    "Increase indent": "Didinti \u012ftrauk\u0105",
    "Inline": "\u012eterptas",
    "Insert": "\u012eterpti",
    "Insert Template": "Prid\u0117ti \u0161ablon\u0105",
    "Insert accordion": "Prid\u0117ti i\u0161skleid\u017eiam\u0105 element\u0105",
    "Insert column after": "\u012eterpti stulpel\u012f po",
    "Insert column before": "\u012eterpti stulpel\u012f prie\u0161",
    "Insert date/time": "\u012eterpti dat\u0105/laik\u0105",
    "Insert image": "\u012eterpti paveiksl\u0117l\u012f",
    "Insert link (if link plugin activated)": "Prid\u0117ti nuorod\u0105 (jei link priedas aktyvuotas)",
    "Insert row after": "\u012eterpti eilut\u0119 po",
    "Insert row before": "\u012eterpti eilut\u0119 prie\u0161",
    "Insert table": "\u012eterpti lentel\u0119",
    "Insert template...": "Prid\u0117ti \u0161ablon\u0105...",
    "Insert video": "\u012eterpti video",
    "Insert/Edit code sample": "Prid\u0117ti / keisti kodo pavyzd\u012f",
    "Insert/edit image": "\u012eterpti|Tvarkyti paveiksl\u0117l\u012f",
    "Insert/edit link": "\u012eterpti/taisyti nuorod\u0105",
    "Insert/edit media": "Prid\u0117ti / keisti medij\u0105",
    "Insert/edit video": "\u012eterpti/tvarkyti video",
    "Inset": "\u012e vid\u0173",
    "Invalid hex color code: {0}": "Neteisingas spalvos \u0161e\u0161ioliktainis kodas: {0}",
    "Invalid input": "Neteisinga \u012fvestis",
    "Italic": "Kursyvinis",
    "Justify": "I\u0161d\u0117styti per vis\u0105 plot\u012f",
    "Keyboard Navigation": "Valdymas klaviat\u016bra",
    "Language": "Kalba",
    "Learn more...": "Su\u017einoti daugiau...",
    "Left": "Kair\u0117",
    "Left to right": "I\u0161 kair\u0117s \u012f de\u0161in\u0119",
    "Light Blue": "\u0160viesiai m\u0117lyna",
    "Light Gray": "\u0160viesiai pilka",
    "Light Green": "\u0160viesiai \u017ealia",
    "Light Purple": "\u0160viesiai violetin\u0117",
    "Light Red": "\u0160viesiai raudona",
    "Light Yellow": "\u0160viesiai geltona",
    "Line height": "Eilut\u0117s auk\u0161tis",
    "Link list": "Nuorod\u0173 s\u0105ra\u0161as",
    "Link...": "Nuoroda...",
    "List Properties": "S\u0105ra\u0161o Savyb\u0117s",
    "List properties...": "S\u0105ra\u0161o savyb\u0117s...",
    "Loading emojis...": "Kraunami jaustukai...",
    "Loading...": "Kraunama...",
    "Lower Alpha": "Ma\u017eosios raid\u0117s",
    "Lower Greek": "Ma\u017eosios graik\u0173",
    "Lower Roman": "Ma\u017eosios rom\u0117n\u0173",
    "Match case": "Atitinkamus",
    "Mathematical": "Matematinis",
    "Media poster (Image URL)": "medijos skelbiklis (paveiksl\u0117lio URL adresas)",
    "Media...": "Medija...",
    "Medium Blue": "Vidutini\u0161kai m\u0117lyna",
    "Medium Gray": "Vidutini\u0161kai pilka",
    "Medium Purple": "Vidutini\u0161kai violetin\u0117",
    "Merge cells": "Sujungti langelius",
    "Middle": "Viduryje",
    "Midnight Blue": "Vidurnak\u010dio m\u0117lyna",
    "More...": "Daugiau...",
    "Name": "Pavadinimas",
    "Navy Blue": "Tamsiai m\u0117lyna",
    "New document": "Naujas dokumentas",
    "New window": "Naujas langas",
    "Next": "Sekantis",
    "No": "Ne",
    "No alignment": "Be lygiavimo",
    "No color": "Jokios spalvos",
    "Nonbreaking space": "Nepertraukiamos vietos",
    "None": "Nieko",
    "Numbered list": "Skaitmeninis s\u0105ra\u0161as",
    "OR": "ARBA",
    "Objects": "Objektai",
    "Ok": "Gerai",
    "Open help dialog": "Atverti pagalbos lang\u0105",
    "Open link": "Atidaryti nuorod\u0105",
    "Open link in...": "Nuorod\u0105 atverti...",
    "Open popup menu for split buttons": "Atverti i\u0161\u0161okant\u012f meniu padalijimo mygtukams",
    "Orange": "Oran\u017ein\u0117",
    "Outset": "\u012e i\u0161or\u0119",
    "Page break": "Puslapio skirtukas",
    "Paragraph": "Paragrafas",
    "Paste": "\u012ed\u0117ti",
    "Paste as text": "\u012eklijuoti kaip tekst\u0105",
    "Paste column after": "\u012eklijuoti stulpel\u012f po",
    "Paste column before": "\u012eklijuoti stulpel\u012f prie\u0161",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Dabar \u012fterpiama paprastojo teksto re\u017eimu. Kol \u0161i parinktis \u012fjungta, turinys bus \u012fterptas kaip paprastas tekstas.",
    "Paste or type a link": "\u012eklijuokite arba \u012fra\u0161ykite nuorod\u0105",
    "Paste row after": "\u012ed\u0117ti eilut\u0119 po",
    "Paste row before": "\u012ed\u0117ti eilut\u0119 prie\u0161",
    "Paste your embed code below:": "\u012eterpkite kod\u0105 \u017eemiau:",
    "People": "\u017dmon\u0117s",
    "Plugins": "Priedai",
    "Plugins installed ({0}):": "\u012ediegti priedai ({0}):",
    "Powered by {0}": "Sukurta {0}",
    "Pre": "Pre",
    "Preferences": "Nustatymai",
    "Preformatted": "Suformuotas i\u0161 anksto",
    "Premium plugins:": "Mokami priedai:",
    "Press the Up and Down arrow keys to resize the editor.": "Paspaud\u0119 mygtukus Auk\u0161tyn ir \u017demyn pakeisite redaktoriaus dyd\u012f.",
    "Press the arrow keys to resize the editor.": "Paspaud\u0119 rodykli\u0173 mygtukus pakeisite redaktoriaus dyd\u012f.",
    "Press {0} for help": "Spustel\u0117j\u0119 {0} gausite pagalbos",
    "Preview": "Per\u017ei\u016bra",
    "Previous": "Ankstesnis",
    "Print": "Spausdinti",
    "Print...": "Spausdinti...",
    "Purple": "Ro\u017ein\u0117",
    "Quotations": "Citata",
    "R": "R",
    "Range 0 to 255": "Nuo 0 iki 255",
    "Red": "Raudona",
    "Red component": "Raudonas komponentas",
    "Redo": "Redo",
    "Remove": "Pa\u0161alinti",
    "Remove color": "Pa\u0161alinti spalv\u0105",
    "Remove link": "\u0160alinti nuorod\u0105",
    "Replace": "Pakeisti",
    "Replace all": "Pakeisti visk\u0105",
    "Replace with": "Kuo pakeisti",
    "Resize": "Keisti dyd\u012f",
    "Restore last draft": "Atstatyti paskutin\u012f projekt\u0105",
    "Reveal or hide additional toolbar items": "Rodyti ar sl\u0117pti papildomus \u012franki\u0173 juostos elementus",
    "Rich Text Area": "Rai\u0161kiojo teksto vieta",
    "Rich Text Area. Press ALT-0 for help.": "Rai\u0161kiojo teksto vieta. Spustel\u0117j\u0119 Alt-0 gausite pagalbos.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Suformatuoto teksto laukas. D\u0117l meniu spauskite ALT-F9. U\u017eduo\u010di\u0173 juostos \u012fjungimui spauskite ALT-F10. Pagalbai - spauskite ALT-0.",
    "Ridge": "Lau\u017eytas",
    "Right": "De\u0161in\u0117",
    "Right to left": "I\u0161 de\u0161in\u0117s \u012f kair\u0119",
    "Row": "Eilut\u0117s",
    "Row clipboard actions": "Eilut\u0117s main\u0173 srities veiksmai",
    "Row group": "Eilu\u010di\u0173 grup\u0117",
    "Row header": "Eilut\u0117s antra\u0161t\u0117",
    "Row properties": "Eilut\u0117s savyb\u0117s",
    "Row type": "Eilu\u010di\u0173 tipas",
    "Rows": "Eilut\u0117s",
    "Save": "I\u0161saugoti",
    "Save (if save plugin activated)": "I\u0161saugoti (jei save priedas aktyvuotas)",
    "Scope": "Strukt\u016bra",
    "Search": "Ie\u0161koti",
    "Select all": "Pa\u017eym\u0117ti visk\u0105",
    "Select...": "Pasirinkti...",
    "Selection": "Pasirinkimas",
    "Shortcut": "Nuoroda",
    "Show blocks": "Rodyti blokus",
    "Show caption": "Rodyti antra\u0161t\u0119",
    "Show invisible characters": "Rodyti nematomus simbolius",
    "Size": "Dydis",
    "Solid": "I\u0161tisinis",
    "Source": "Pirmin\u0117 nuoroda",
    "Source code": "Pirminis \u0161altinis",
    "Special Character": "Specialusis simbolis",
    "Special character...": "Specialieji simboliai...",
    "Split cell": "Skaidyti langelius",
    "Square": "Kvadratas",
    "Start list at number": "S\u0105ra\u0161\u0105 prad\u0117kite skai\u010diu",
    "Strikethrough": "Perbrauktas",
    "Style": "Stilius",
    "Subscript": "Apatinis indeksas",
    "Superscript": "Vir\u0161utinis indeksas",
    "Switch to or from fullscreen mode": "Perjungti i\u0161/\u012f viso ekrano rodym\u0105",
    "Symbols": "Simboliai",
    "System Font": "Sisteminiai \u0161riftai",
    "Table": "Lentel\u0117",
    "Table caption": "Lentel\u0117s antra\u0161t\u0117",
    "Table properties": "Lentel\u0117s savyb\u0117s",
    "Table styles": "Lentel\u0117s stiliai",
    "Template": "\u0160ablonas",
    "Templates": "\u0160ablonai",
    "Text": "Tekstas",
    "Text color": "Teksto spalva",
    "Text color {0}": "Teksto spalva {0}",
    "Text to display": "Rodomas tekstas",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Atrodo, kad \u012fvesta nuoroda yra elektroninio pa\u0161to adresas. Ar norite prie\u0161 j\u012f \u012fvesti reikalaujam\u0105 \u201emailto:\u201c?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Atrodo, kad \u012fved\u0117te nuotolin\u0119 nuorod\u0105. Ar norite prie\u0161 j\u0105 \u012fvesti reikalaujam\u0105 \u201ehttp://\u201c?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Pana\u0161u, kad \u012fra\u0161\u0117te nuotolin\u0119 nuorod\u0105. Ar norite jos prad\u017eioije prid\u0117ti b\u016btin\u0105 \u201ehttps://\u201c?",
    "Title": "Pavadinimas",
    "To open the popup, press Shift+Enter": "Spustel\u0117j\u0119 Shift+Enter atversite i\u0161kylant\u012f lang\u0105",
    "Toggle accordion": "Kaitalioti i\u0161skleid\u017eiam\u0105 element\u0105",
    "Tools": "\u012erankiai",
    "Top": "Vir\u0161uje",
    "Travel and Places": "Kelion\u0117s ir vietos",
    "Turquoise": "\u017dalsvai m\u0117lyna",
    "Underline": "Pabrauktas",
    "Undo": "Atstatyti",
    "Upload": "\u012ekelti",
    "Uploading image": "\u012ekelti paveiksliuk\u0105",
    "Upper Alpha": "Did\u017eiosios raid\u0117s",
    "Upper Roman": "Did\u017eiosios rom\u0117n\u0173",
    "Url": "Nuoroda",
    "User Defined": "Vartotojo apibr\u0117\u017eta",
    "Valid": "Tinkamas",
    "Version": "Versija",
    "Vertical align": "Vertikalus lygiavimas",
    "Vertical space": "Vertikalus tarpas",
    "View": "Per\u017ei\u016bra",
    "Visual aids": "Vaizdin\u0117s priemon\u0117s",
    "Warn": "\u012esp\u0117ti",
    "White": "Balta",
    "Width": "Plotis",
    "Word count": "\u017dod\u017ei\u0173 kiekis",
    "Words": "\u017dod\u017ei\u0173",
    "Words: {0}": "\u017dod\u017eiai: {0}",
    "Yellow": "Geltona",
    "Yes": "Taip",
    "You are using {0}": "Naudojate {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Turite nei\u0161saugot\u0173 pakeitim\u0173! Ar tikrai norite i\u0161eiti?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Nar\u0161ykl\u0117s nustatymai neleid\u017eia redaktoriui tiesiogiai pasiekti laikinosios atminties. Pra\u0161ome naudoti klaviat\u016bros klavi\u0161us Ctrl+X/C/V.",
    "alignment": "lygiavimas",
    "austral sign": "australo \u017eenklas",
    "cedi sign": "sed\u017eio \u017eenklas",
    "colon sign": "dvita\u0161kio \u017eenklas",
    "cruzeiro sign": "kruzeiro \u017eenklas",
    "currency sign": "valiutos \u017eenklas",
    "dollar sign": "dolerio \u017eenklas",
    "dong sign": "dongo \u017eenklas",
    "drachma sign": "drachmos \u017eenklas",
    "euro-currency sign": "euro \u017eenklas",
    "example": "pavyzdys",
    "formatting": "formatavimas",
    "french franc sign": "Pranc\u016bz\u0173 franko \u017eenklas",
    "german penny symbol": "Vokietijos fenigo \u017eenklas",
    "guarani sign": "gvaranio \u017eenklas",
    "history": "praeitis",
    "hryvnia sign": "grivinos \u017eenklas",
    "indentation": "\u012ftrauka",
    "indian rupee sign": "Indijos rupijos \u017eenklas",
    "kip sign": "kipo \u017eenklas",
    "lira sign": "lyros \u017eenklas",
    "livre tournois sign": "toro svaro \u017eenklas",
    "manat sign": "manato \u017eenklas",
    "mill sign": "milo simbolis",
    "naira sign": "nairos simbolis",
    "new sheqel sign": "naujojo \u0161ekelio \u017eenklas",
    "nordic mark sign": "\u0161iaur\u0117s \u0161ali\u0173 mark\u0117s \u017eenklas",
    "peseta sign": "peseto \u017eenklas",
    "peso sign": "peso \u017eenklas",
    "ruble sign": "rublio \u017eenklas",
    "rupee sign": "rupijos \u017eenklas",
    "spesmilo sign": "spesmilo \u017eenklas",
    "styles": "stiliai",
    "tenge sign": "teng\u0117s \u017eenklas",
    "tugrik sign": "tugriko \u017eenklas",
    "turkish lira sign": "Turkijos lyros \u017eenklas",
    "won sign": "vono \u017eenklas",
    "yen character": "jienos simbolis",
    "yen/yuan character variant one": "jienos/juanio vieningas \u017eenklas",
    "yuan character": "juanio simbolis",
    "yuan character, in hong kong and taiwan": "juanio \u017eenklas, naudojamas Hongkonge ir Taivane",
    "{0} characters": "{0} simboliai",
    "{0} columns, {1} rows": "stulpeli\u0173: {0}, eilu\u010di\u0173: {1}",
    "{0} words": "{0} \u017eod\u017eiai"
});